module.exports = __webpack_public_path__ + "img/4.fadf10b9.jpg";